<template>
  <div class="subject-items-box">
    <div class="banner">
      <img class="banner-img" :src="subject.bigLogoImg" alt="">
      <div class="to-subject" @click="toSubject(subject.id)">查看课程详情</div>
    </div>

    <div class="course-notice">
      <div class="course-notice__item">
        <div class="course-notice__icon">
          <img src="@/assets/icons/hood_icon.png" alt="">
        </div>
        <div class="course-notice__text">{{subject.updateDesc}}</div>
      </div>
      <div class="course-notice__item">
        <div class="course-notice__icon">
          <img src="@/assets/icons/hood_icon.png" alt="">
        </div>
        <!-- <div class="course-notice__text">微信公众号观看</div> -->
      </div>
    </div>

    <div class="share-bar" v-if="subject.isFullPurchase">
      <div class="share-hd">
        <img class="banner-img" src="@/assets/icons/share_bar_icon.png" alt="">
      </div>
      <div class="share-bd">
        <div class="share-bd__title">
          分享赚￥<span>{{subject.bonus}}</span>
        </div>
        <div class="share-bd__desc" @click="toProfit">奖学金活动规则 <van-icon name="arrow" size="10px" /></div>
      </div>
      <div class="share-ft">
        <div class="share-btn" @click="createPoster">
          <img src="@/assets/icons/poster_icon.png" alt="">
          <p>专属海报</p>
        </div>
        <div class="share-btn" @click="inviteFriends">
          <img src="@/assets/icons/share_icon.png" alt="">
          <p>一键分享</p>
        </div>
      </div>
    </div>

    <div class="only-bought-desc" v-if="subject.onlyBought">
      <h3>上课须知</h3>
      <p>1. 当前课程为直播课，请扫码加入微信直播群~</p>
      <p>2. 非正式上课期间直播间不开放哦~</p>
      <img class="group-qrcode" :src="subject.groupQrcodeImg" alt="">
    </div>

    <div class="course-list" v-if="subjectItems.length > 0">
      <ul class="courses">
        <li class="course" :class="[item.isUnlocked ? 'unlocked' : 'locked', item.learnStatus]" v-for="(item, index ) in subjectItems" :key="index" @click="toDetail(item)">{{ item.title }}</li>
      </ul>
      <div class="course-btn" @click="showMore">{{ showAll ? '收起课程' : '显示全部课程' }} <van-icon :name="showAll ? 'arrow-up' : 'arrow-down'" /></div>
    </div>

    <Poster :show="showPosterPopup" :posterData="posterData" @close="showPosterPopup=false" />

    <!-- 邀请弹框 -->
    <SharePopup :show="showInvite" @close="showInvite=false" />
    <div class="recommend" v-if="!subject.isSingle">
      <div class="recommend-title">
        <span>为你推荐</span>
      </div>
      <div class="recommend-list">
        <div class="recommend-item" v-for="(item, index) in recommends" :key="index" @click="toSubject(item.id)">
          <div class="recommend-item__top">
            <img class="recommend-img" :src="item.smallLogoImg" alt="">
          </div>
          <div class="recommend-item__bottom">
            <div class="recommend-item__title van-ellipsis">{{ item.title }}</div>
            <div class="recommend-item__desc van-ellipsis">{{ item.subTitle }}</div>
            <div class="recommend-item__price">
              ￥{{ item.isGroup ? item.groupPrice : item.fullPrice }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <Subscribe :isSubscribe="user.subscribe" />
  </div>
</template>

<script>
import { getMyLearnData } from './query.gql'
import Poster from '@/components/Poster'
// import ServiceStick from '@/components/ServiceStick'
import SharePopup from '@/components/SharePopup'
import Subscribe from '@/components/Subscribe'

export default {
  name: 'learn',
  data() {
    return {
      subjectItems: [],
      showAll: false,
      recommends: [],
      user: '',
      // showFocusPopup: false,
      showPosterPopup: false,
      posterData: null,
      wxShareLink: '',
      showInvite: false, // 邀请好友
      subject: {} // 课程详情
    }
  },
  components: {
    Poster,
    // ServiceStick,
    SharePopup,
    Subscribe
  },
  async mounted() {
    await this.weixinAuth()
    console.log('进入课程列表')
    const { id } = this.$route.query
    if (id) {
      this.loadData(parseInt(id))
    } else {
      console.error('page: classroom/learn。进入页无参数id')
    }
  },
  methods: {
    showMore() {
      this.showAll = !this.showAll
      if (this.showAll) {
        this.subjectItems = this.subject.subjectItems
      } else {
        this.subjectItems = this.subject.subjectItems.slice(0, 4)
      }
    },
    toDetail(item) {
      if (item.isUnlocked) {
        this.loadPage('detail', { sid: this.subject.id, id: item.id })
      } else {
        this.$toast.fail('课程尚未解锁')
      }

      // const self = this
      // self.$zhuge.track('课程列表查看课时', {
      //   '课程名称': self.subject.title,
      //   '课时名称': item.title
      // })
    },
    toSubject(id) {
      this.$router.push({
        name: 'subject',
        query: { id }
      })

      // this.$zhuge.track('课程列表-课程详情', {
      //   '课程ID': id
      // })
    },
    toProfit() {
      this.$router.replace({
        name: 'profit'
      })
    },
    // 邀请好友
    inviteFriends() {
      this.showInvite = true

      // const self = this
      // self.$zhuge.track('课程列表邀请好友', {
      //   '课程名称': self.subject.title
      // })
    },
    loadData(id) {
      // 请求数据
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      self.$apollo.query({
        query: getMyLearnData,
        variables: { subjectId: id, ignoreStatus: true },
        fetchPolicy: 'no-cache'
      }).then(res => {
        self.user = res.data.profile
        self.subject = res.data.subject
        self.subjectItems = self.subject.subjectItems.slice(0, 4)
        let recommends = res.data.subjects.nodes
        self.recommends = recommends.filter(item => item.id !== id).slice(0, 3)
        // self.showFocusPopup = !self.user.subscribe
        let num = Math.floor(Math.random() * 11) + 10
        self.wxShareLink = `${window.location.origin}/?#/invite/${self.subject.id}?invitationCode=${self.user.invitationCode}`
        self.wechatShare({
          title: `${num}人正在拼→${self.subject.shareTitle}`,
          imgUrl: self.subject.smallLogoImg,
          desc: self.subject.shareContent,
          link: self.wxShareLink
        })
        console.log(res)
        self.$toast.clear()
        // self.$zhuge.identify(self.user.id, {
        //   name: self.user.nickname,
        //   avatar: self.user.avatar
        // })
      }).catch(err => {
        console.error('page：classroom/learn。请求getSubjectWithItems报错', err)
        self.$toast.fail('加载数据出错')
      })
    },
    createPoster() {
      // 生成海报
      const self = this
      self.posterData = {
        user: {
          avatar: self.user.avatar,
          nickname: self.user.nickname
        },
        posterTplImg: self.subject.posterTplImg,
        wxShareLink: self.wxShareLink
      }
      self.showPosterPopup = true

      // self.$zhuge.track('课程列表生成海报', {
      //   '课程名称': self.subject.title
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.subject-items-box {
  min-height: 100vh;
  background: #fce9d0;
  .banner {
    // height: 140px;
    position: relative;
    overflow: hidden;
    .banner-img {
      width: 100vw;
      max-height: 280px;
    }
    .to-subject{
      line-height: 30px;
      padding: 0 12px;
      position: absolute;
      left: 0;
      bottom: 36px;
      color: #fff;
      font-size: 14px;
      background: #ff6400;
      border-top-right-radius: 15px;
      border-bottom-right-radius: 15px;
      box-shadow: 0 0 5px rgba(255, 255, 255, .6)
    }
    .commentEntry-img {
      width: 75.5px;
      position: absolute;
      left: 0;
      bottom: 12px;
    }
  }
  .course-notice {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    padding: 4px 0;
    margin-bottom: 15px;
    .course-notice__item {
      display: flex;
      align-items: center;
      .course-notice__icon {
        background: #ffa067;
        width: 16px;
        height: 16px;
        border-radius: 8px;
        padding: 2.25px;
        box-sizing: border-box;
        margin: 0 6px;
        img{
          width: 11.5px;
        }
      }
      .course-notice__text {
        font-size: 13px;
        color: #4c4c4c;
      }
    }
  }
  .course-list {
    .courses {
      .course {
        width: 90vw;
        height: 20vw;
        margin: 1vw auto auto;
        line-height: 18vw;
        padding-left: 5vw;
        box-sizing: border-box;
        &.unlocked {
          background: url('~@/assets/images/course_list_unlock_bg.png') no-repeat;
          background-size: 100%;
          color: #895630;

        }
        &.locked {
          background: url('~@/assets/images/course_list_lock_bg.png') no-repeat;
          background-size: 100%;
          color: #fff;
        }
        &.learned {
          background: url('~@/assets/images/course_list_studied_bg.png') no-repeat;
          background-size: 100%;
        }
      }
    }
    .course-btn{
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 120px;
      margin: 0 auto;
      padding: 10px 0;
      .van-icon{
        margin-left: 5px;
      }
    }
  }
  .share-bar {
    border: 3px solid #ffa067;
    display: flex;
    align-items: center;
    overflow: hidden;
    background: #fff;
    border-radius: 8px;
    min-height: 54px;
    margin: 0 21.5px 10px;
    .share-hd {
      padding-left: 13.5px;
      padding-right: 10px;
      img {
        width: 50px;
      }
    }
    .share-bd {
      flex: 1;
      .share-bd__title {
        color: #ff4200;
        font-size: 21px;
        font-weight: bold;
      }
      .share-bd__desc {
        font-size: 13px;
        color: #ff4545;
        padding-top: 5px;
      }
    }
    .share-ft {
      display: flex;
      .share-btn {
        color: #ff6400;
        font-weight: bold;
        text-align: center;
        font-size: 11px;
        padding: 0 10px;
        & + .share-btn {
          border-left: 1px solid #ff7800;
        }
        img {
          width: 30px;
          height: 30px;
          margin: 0 auto;
          padding-bottom: 3px;
        }
      }
    }
  }
  .recommend {
    padding: 40px 15px 20px 15px;
    .recommend-title {
      display: flex;
      align-items: center;
      justify-content: center;
      &:before,&:after {
        content: '';
        width: 20px;
        height: 1px;
        background: #ffb000;
      }
      span {
        color: #ffb000;
        font-size: 14px;
        margin: 0 10px;
      }
    }
    .recommend-list {
      .recommend-item {
        margin-top: 15px;
        border-radius: 10px;
        overflow: hidden;
        background: #fff;
        display: flex;
        .recommend-item__top {
          position: relative;
          .recommend-img {
            width: 100px;
          }
        }
        .recommend-item__bottom {
          padding: 10px;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .recommend-item__title {
            color: #4c4c4c;
            font-weight: bold;
            font-size: 16px;
            width: 220px;
          }
          .recommend-item__desc {
            width: 220px;
            font-size: 12px;
            color: #9b9b9b;
          }
          .recommend-item__price {
            color: #ff4800;
          }
        }
      }
    }
  }
  .focus-popup{
    text-align: center;
    .focus-popup__hd{
      font-size: 16px;
      color: #282828;
      font-weight: bold;
      padding: 16px 0;
    }
    .focus-popup__bd{
      color: #666;
      font-size: 14px;
      line-height: 1.5em;
      margin-bottom: 10px;
      .qr{
        width: 168px;
        height: 168px;
        display: block;
        margin: 0 auto;
        padding-bottom: 16px;
      }
    }
    .focus-popup__ft{
      padding: 16px 52px;
      .focus-popup__ft-btn{
        &.van-button--warning{
          background-color: #FF771D;
          border-color: #FF771D;
        }
      }
    }
    .close_btn {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 44px;
      height: 44px;
      img {
        width: 22px;
        height: 22px;
        margin: auto;
      }
    }
  }

  .only-bought-desc{
    background: #fff;
    margin: 15px;
    border-radius: 5px;
    padding: 15px;
    text-align: center;
    color: #4c4c4c;
    line-height: 2em;
    p{
      text-align: left;
    }

    h3{
      color: #ff6400;
    }
    .group-qrcode{
      display: inline-block;
      width: 160px;
      height: 160px;
    }
  }
}
</style>
